import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { finalize, Observable } from "rxjs";
import { SpinnerService } from "./spinner.service";

@Injectable()
export class LoadingScreenInterceptor implements HttpInterceptor {
 activeRequests: number = 0;

  skippUrls = [
    '/authrefresh',
  ];
constructor(
    private spinnerSrv: SpinnerService
){}
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let displayLoadingScreen = true
        
        for(const skippUrl of this.skippUrls){
            if(new RegExp(skippUrl).test(req.url)){
                displayLoadingScreen = false;
                break;
            }
        }
        if(displayLoadingScreen){
            if(this.activeRequests === 0){
                this.spinnerSrv.startLoading();
            }
            this.activeRequests++;

            return next.handle(req).pipe(
                finalize(() => {
                    this.activeRequests--;
                    if(this.activeRequests === 0){
                        this.spinnerSrv.stopLoading();
                    }
                } )
            )
        } else {
            return next.handle(req)
        }
    }
    
}